import { fromPromise } from 'rxjs/observable/fromPromise';
import { map, switchMap } from 'rxjs/operators';
import { setInfuseConfig } from './actions';
import { getInfuseConfig } from '../../../api/infuse/service';

/* eslint-disable import/prefer-default-export */
export const AUTH_GET_INFUSE_CONFIG = (action$) =>
  action$.pipe(
    switchMap(({ data }) =>
      fromPromise(getInfuseConfig(data)).pipe(map(({ data }) => setInfuseConfig(data)))
    )
  );
